module.exports = __webpack_public_path__ + "static/media/pago4.84ef1423.svg";